import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { Session } from '@supabase/supabase-js';

export const useAuth = () => {
    const [session, setSession] = useState<Session | null>(null);
    const [profile, setProfile] = useState<any | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const fetchProfile = async (_userId: string) => {
        // v2 profile logic will eventually go here
        return { full_name: 'Developer Mode' };
    };

    useEffect(() => {
        // Initial session check
        supabase.auth.getSession().then(({ data: { session } }) => {
            setSession(session);
            if (session) {
                fetchProfile(session.user.id).then(p => {
                    setProfile(p);
                    setLoading(false);
                });
            } else {
                setLoading(false);
            }
        });

        // Listen for auth changes
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session);
            if (session) fetchProfile(session.user.id).then(setProfile);
        });

        return () => subscription.unsubscribe();
    }, []);

    const logout = async () => {
        await supabase.auth.signOut();
        setSession(null);
        setProfile(null);
        window.location.reload();
    };

    return { 
        session, 
        user: session?.user || null,
        profile, 
        loading, 
        logout, 
        setProfile, 
        setLoading 
    };
};
